/**
 * Bozze Studio in lista Svincolati (prezzo / note / tag senza slot).
 * Persistenza durable su localStorage per access_key (sopravvive a chiusura tab/sessione).
 */

const KEY_PREFIX = 'fantapp:v2:studioDrafts:';

function storageKey(accessKey) {
  return `${KEY_PREFIX}${String(accessKey || '').trim()}`;
}

export function normalizeStudioDraft(input = {}) {
  const maxPrice = Number(input.maxPrice);
  const labels = Array.isArray(input.labels)
    ? input.labels.map((l) => String(l || '').trim()).filter(Boolean)
    : [];
  return {
    maxPrice: Number.isFinite(maxPrice) && maxPrice > 0 ? maxPrice : 0,
    notes: String(input.notes || '').trim(),
    labels,
  };
}

export function isStudioDraftEmpty(draft) {
  const d = normalizeStudioDraft(draft);
  return !(d.maxPrice > 0) && !d.notes && d.labels.length === 0;
}

export function mergeStudioDraft(current, fields = {}) {
  const base = normalizeStudioDraft(current);
  const next = { ...base };
  if (fields.maxPrice !== undefined) {
    const n = Number(fields.maxPrice);
    next.maxPrice = Number.isFinite(n) && n > 0 ? n : 0;
  }
  if (fields.notes !== undefined) next.notes = String(fields.notes || '').trim();
  if (fields.labels !== undefined) {
    next.labels = Array.isArray(fields.labels)
      ? fields.labels.map((l) => String(l || '').trim()).filter(Boolean)
      : [];
  }
  return normalizeStudioDraft(next);
}

export function draftsMapToObject(map) {
  const out = {};
  if (!(map instanceof Map)) return out;
  for (const [key, draft] of map.entries()) {
    const n = normalizeStudioDraft(draft);
    if (!isStudioDraftEmpty(n)) out[key] = n;
  }
  return out;
}

export function objectToDraftsMap(obj) {
  const map = new Map();
  if (!obj || typeof obj !== 'object') return map;
  for (const [key, draft] of Object.entries(obj)) {
    const n = normalizeStudioDraft(draft);
    if (!isStudioDraftEmpty(n)) map.set(key, n);
  }
  return map;
}

export function loadStudioDraftsFromStorage(accessKey) {
  if (!accessKey || typeof localStorage === 'undefined') return new Map();
  try {
    const raw = localStorage.getItem(storageKey(accessKey));
    if (!raw) return new Map();
    return objectToDraftsMap(JSON.parse(raw));
  } catch {
    return new Map();
  }
}

export function saveStudioDraftsToStorage(accessKey, map) {
  if (!accessKey || typeof localStorage === 'undefined') return false;
  try {
    const payload = draftsMapToObject(map);
    if (Object.keys(payload).length === 0) {
      localStorage.removeItem(storageKey(accessKey));
      return true;
    }
    localStorage.setItem(storageKey(accessKey), JSON.stringify(payload));
    return true;
  } catch {
    return false;
  }
}
